import React from 'react';
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

export default function ArgoTemplateListDividerHook(props) {

    const fileName = props.fileName;

    const parentsLabel = props.parentsLabel;

    const arrayLength = props.arrayLength;

    const childLabel = arrayLength === 1 ? props.childLabel[0] : props.childLabel[1];

    const isShowGroups = props.isShowGroups ? props.isShowGroups : false;

    return (
        <div>
            <Divider id={fileName + "-divider-ArgoTemplateListDividerHook"}>
            {
                isShowGroups ?
                    <Typography variant="subtitle1">
                        {"Contains (" + arrayLength + ") show groups"}
                    </Typography>
                    :
                    <Typography variant="subtitle1">
                        {parentsLabel + " assigned (" + arrayLength + ") " + childLabel}
                    </Typography>
            }
            </Divider>
            <div>&nbsp;</div>
        </div>
    );
}


